import { VerifiedPropertyIcon } from '@/card/card-viewer/property-card/property-card-styles';
import { fallbackTexts } from '@/constants';
import styled from 'styled-components';
import { StreetAddress } from '../../license/components/license-content-styles';
import { ViolationAndComplaintReport } from './details-info-modules/issue-report-panes/violation-and-complaint-report-pane';
import { LicenseInfoMod } from './details-info-modules/license-info-mod';
import { ListingsMod } from './details-info-modules/listings-mod';
import { LocationMod } from './details-info-modules/location-mod';
import { PropertyInfoMod } from './details-info-modules/property-info-mod';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  min-width: 580px;
  max-width: 1622px;

  margin-top: 37px;
  padding-bottom: 20px;

  @media print {
    display: block !important;
    min-width: 500px !important;
    max-width: 500px !important;
    padding: 0px;
  }
`;

const initialListingPlatform = 'all';
function filterByCurrentPlatform(listings, currentPlatform) {
  if (currentPlatform === initialListingPlatform) return listings;
  return listings.filter((listing) => listing.platform === currentPlatform);
}

function platformListings(listings) {
  const platformList = listings || [];
  const platformsWithDups = platformList.map((listing) => listing.platform);
  // remove dups
  const uniquePlatforms = [...new Set(platformsWithDups)];
  return uniquePlatforms;
}

/**
 * @export
 * @param data - Property Data, contains all data regarding specific property.  E.g. deckardid,
 *  ltrLicense, address, etc.
 * @param onMapClick - Function to bring user back to home page.
 * @param setLocationImageLoaded - Informs PropertyDetailsContent when it is ok to take a snapshot
 *  of property info as image.
 * @param currentPlatform - Hook that keeps track of the current platform, used in
 *  property-details-content to pre-render property details snapshot for print functionality.
 * @param setCurrentPlatform - Setter for currentPlatform hook.
 * @param {boolean} props.isComplaintsEnabled Whether complaints are enabled for the current place
 * @returns
 */

export function DetailsInfo(props) {
  const {
    complaints,
    isComplaintsEnabled,
    data,
    onMapClick,
    currentPlatform,
    setCurrentPlatform,
    platformIcons,
  } = props;

  // ! TODO: monday ticket 655249299
  const listingData = data.listings || data.onlinePlatformsUrls;
  const platformList = platformListings(listingData);

  return (
    <Wrapper id="property-details-info">
      <StreetAddress data-cy="property-details-header-address">
        {data.address || fallbackTexts.PENDING_IDENTIFICATION}
        <VerifiedPropertyIcon verifiedStatus={data.verifiedStatus} />
      </StreetAddress>

      {(data.listings || Boolean(complaints)) && (
        <>
          <ViolationAndComplaintReport
            complaints={complaints}
            hideComplaints={!isComplaintsEnabled}
            listings={data.listings}
          />

          <LicenseInfoMod
            strLicense={data.strLicense}
            ltrLicense={data.ltrLicense}
            occupancyAllowed={data.occupancyAllowed}
            bedroomsLicensed={data.bedroomsLicensed}
            inspectionResult={data.lastInspectionResult}
            inspectionDate={data.lastInspectionDate}
          />
        </>
      )}

      <ListingsMod
        propertyData={data}
        listingData={listingData}
        currentPlatform={currentPlatform}
        platformList={platformList}
        platformIcons={platformIcons}
        setCurrentPlatform={setCurrentPlatform}
        filterByCurrentPlatform={filterByCurrentPlatform}
      />

      <LocationMod
        lnglat={[data.lnglat[0], data.lnglat[1]]}
        onClick={onMapClick}
      />

      <PropertyInfoMod
        apn={data.apn}
        bedroom={data.bedrooms}
        bathroom={data.bathrooms}
        owner={data.owner}
        ownerAddress={data.ownerAddress}
        ownerOccupied={data.ownerOccupied}
        rentalStructure={data.rentalStructure}
        latestVerifiedDate={data.latestVerifiedDate}
      />
    </Wrapper>
  );
}
